"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNonHotelRateRefundable = void 0;
const isNonHotelRateRefundable = (data) => {
    // if any of the rates are non-refundable, return true
    for (let i = 0; i < data.length; i++) {
        if (data[i].non_refundable) {
            return true;
        }
    }
    return false;
};
exports.isNonHotelRateRefundable = isNonHotelRateRefundable;
